import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { CommentReaction } from '../../redux/types';
import s from './ReactionsDisplay.scss';
const ReactionsDisplay = ({ comment , reactions , className  })=>{
    const { t  } = useTranslation();
    if (!reactions) {
        return null;
    }
    // This is a temporary & hacky way to determine the number of likes specifically, without other reactions.
    // Since reactions are kept in local storage we only have ours, thus we assume a max count of 1 for non-likes.
    const nonLikesCount = Object.keys(reactions).reduce((acc, reaction)=>reaction === CommentReaction.Like ? acc : acc + 1, 0);
    const totalLikeCount = comment.likes - nonLikesCount;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, totalLikeCount > 0 && /*#__PURE__*/ React.createElement("div", {
        className: s['reaction']
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['reaction-icon'],
        src: "https://st.deviantart.net/emoticons/h/heart.gif",
        alt: t('comment.reactions.like')
    }), ' ', totalLikeCount), reactions[CommentReaction.Love] && /*#__PURE__*/ React.createElement("div", {
        className: s['reaction']
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['reaction-icon'],
        src: "https://st.deviantart.net/emoticons/l/love2.gif",
        alt: t('comment.reactions.love')
    }), ' ', "1"), reactions[CommentReaction.Hug] && /*#__PURE__*/ React.createElement("div", {
        className: s['reaction']
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['reaction-icon'],
        src: "https://st.deviantart.net/emoticons/h/hug.gif",
        alt: t('comment.reactions.hug')
    }), ' ', "1"), reactions[CommentReaction.Bravo] && /*#__PURE__*/ React.createElement("div", {
        className: s['reaction']
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['reaction-icon'],
        src: "https://st.deviantart.net/emoticons/w/worships.gif",
        alt: t('comment.reactions.bravo')
    }), ' ', "1"), reactions[CommentReaction.Wow] && /*#__PURE__*/ React.createElement("div", {
        className: s['reaction']
    }, /*#__PURE__*/ React.createElement("img", {
        className: s['reaction-icon'],
        src: "https://st.deviantart.net/emoticons/l/la.gif",
        alt: t('comment.reactions.wow')
    }), ' ', "1"));
};
ReactionsDisplay.displayName = 'ReactionsDisplay';
export default ReactionsDisplay;
